import {Injectable} from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class UiLoaderService {
  constructor() {
    this.loading$ = new ReplaySubject<loadingStatus>(1);
  }
  public loading$: ReplaySubject<loadingStatus>;
}


export type loadingStatus = {
  status: 'open'|'close',
  title?: string,
  name?: string
}
